import './idroflog.css';
import oftaial_img from '../../assets/oftaial.png';
import { GoDotFill } from 'react-icons/go';
import { useTranslation } from 'react-i18next';

function Oftaial() {
  const { t } = useTranslation('global');

  return (
    <section className="product-hero" aria-labelledby="oftaial-title">
      <div className="product-hero__copy">
        <p className="product-hero__kicker">BeoMedica</p>
        <h1 id="oftaial-title">{t('oftaial.title')}</h1>
        <h2 className="product-hero__subtitle">{t('oftaial.sub_title')}</h2>
        <p>{t('oftaial.paragraph_1')}</p>
        <ul className="product-hero__list">
          <li>
            <GoDotFill aria-hidden="true" /> {t('oftaial.list_item_1')}
          </li>
          <li>
            <GoDotFill aria-hidden="true" /> {t('oftaial.list_item_2')}
          </li>
        </ul>
        <p>{t('oftaial.paragraph_2')}</p>
      </div>
      <div className="product-hero__media">
        <img
          src={oftaial_img}
          alt={t('oftaial.image_alt', { defaultValue: 'Oftaial Plus' })}
        />
      </div>
    </section>
  );
}

export default Oftaial;
